var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_260)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_77_260",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_77_260",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFMUlEQVR4nO2dSYgcVRjHS2OMGoIaXBPEBYQE7yp68CKeFLzEw4gHUVRcYjwKQg4eHAUVcUEEFxARGhfcToKN2NZM1///uspx3FqDF40hSjSL22gs+TJvoBlmMvWq61X3q/7+8C5DT9X3fv29/fteR5FKpVKpVCqVSqVSqVQq1QSp3W6fQnIngBkAh0nmWigMfieZCJt+v79hKMhpmm4F8JmC5VrOlRpjtpSCLN+SQqZL6+2V8mySu9ST6dpN3lMGtPQ/2h+zOAMZx8qAls5eQdMJ9OEyoF0gH4waKjjOtJxf4L3JBCKS3XECfW/UUAG4b1xAp/Pz8ydHDVW/398gdRw16FQWNVHDlabp1qKwnR9+vJEVQCzdRZM9ebmkrlLntbYiIldV9qAhlWXZRpJTAN4kOS8zHFvm7d+m5DN129UY0O12+yS7Oj1YoMn+RvL+Vqu1ri77GgHaGLOFpHEZ7W23BpLn12Fj8KCTJLmE5B5XyAPlO3mGbzuDBp1l2UYAXw4Becmz+51OZ5NPW4MGTfKVYSEPlBc92xomaJJXVAj5WEmS5CqP9gYL+v2qQZN8x6O94YGenZ29GMB/VYOWZ6ZpelGjQMvKieSjJPcC+JHkdNGVI4C7PHjzsWKMuaOIDa72jwy0GLbC56eLvAvAW75Ak3yjYH2d7B8l6L0rfP6ngu/63BdoOWAuaIOT/SMDbZvb8kr+UORdAPZ79Oh9BW1wsn/cuo5HCr7rH4+gFwra4GT/yEDbwWRaPMN1MCR5yCPoQueZrvaPDPQwIvmNR9Bfe7I5SNBv+wIte9aebA4S9C6PoL0cHAcJ2hhzIYCjHiAfTZLkAh82BwlaRPIDDx6tex3LBeDyivc7FkhuizwpWI8WkXy+QtBPRB4VNOg4jk8l+UkFkGdJnubT1qBBi0iePkwAPIAv4jjeHHmWd9AAjojHSEza0Lkb4YWG7bR1P+Id9KSGhAHIijBxfrhDc02b7Nn9xVyeQpB9g2502C4Xu4vCLHyD1kB01gPaPXcjENWRWuFzjzhvaDlU5pucGQPD85BKqS7UNXdDC8sldLrmbmhhr3QGhI1TVthc05FMt9s9L6owd2PVpeekFdhcHpJ3T1Iuj0qlUqlUqjqV5/mJeZ6fUPmD5fwNwLM2cVKmN/8CODBQJFZtj2RDLab68UOJEALwMsmnSD5sg2SmkiS5xhizPU3TM6LAtNpUb1xPp/OB8ieA70m2JYsKwEMkb5Ykn5mZmXOjSQItzYTkHyNaFBwg2QHwgm0R19WVGTtRoLn6FyChte+S3E3y+rq8P+SuI68Q/rc2IfR2GQN8DFbeQdvAlqcB/DpqoCxe9pF8zRhza1WBjt5BL5dc1zA3N3fmUpHjeJssv01i6JIkuZbkDgC3AXhAmjiAZ2wc9Kc2qb7u696+kvQ2AFcXvW6C5Hqpg4wTJH+pHXRV6nQ6m7rd7mXGmBvsRbNPSgQoyTkAf3nsZvYDeInkjauFjvV6vbPttRRrPi8KWa1Wa12v17vUwngQwKs2VKzqxCJpWa/bL3v90rvteqDQM6ImKl4cL66UYyPxyiqunRgo0j08B+Axl/+LJkVZlp1jPVKyqugjr1xBryCZV5O8SbYNJLpUQdckuT3Briw/qrqPlylvXfUISnEcb06S5BZJxq/iKn0AH4+6TqH8fsEOu5xfKAn6zlHXIyiRPMvOZFwitMzSlFBVQrJXQvJxkj8fx5OzSQjCr0U2Wku6lvfk0APA3/KjCbKtIN1OPVaoVCqVSqVSRQ76H7Sbs3rebCI5AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.40e073d66d978e83410dd881f1a05919.svg";
export { ForwardRef as ReactComponent };